import { render, staticRenderFns } from "./Indications.vue?vue&type=template&id=289d91e7&scoped=true&"
import script from "./Indications.vue?vue&type=script&lang=js&"
export * from "./Indications.vue?vue&type=script&lang=js&"
import style0 from "./Indications.vue?vue&type=style&index=0&id=289d91e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d91e7",
  null
  
)

export default component.exports